module.exports = "<p>data-table works!</p>\n"